import React, { Fragment } from 'react';
import { Form, Select } from 'antd';
import { getData } from 'country-list';
import { object, func, string, bool } from 'prop-types';

import { URL } from '../../utils/regexp';
import { ReactQuillWrapped } from '../react-quill';
import { getMaxFieldLengthRule } from '../../utils';
import {
  Title,
  FormItem,
  InputField,
  ButtonSave,
  CancelButton,
  StyledSelect,
  ButtonWrapper,
} from './styled-components';

const { Option } = Select;

const CompanyForm = ({
  form: { getFieldDecorator },
  company: {
    name,
    businessAddress,
    website,
    linkedIn,
    country,
    summary,
  },
  title,
  isLoading,
  closeModal,
  onSubmitForm,
}) => (
  <Fragment>
    <Form onSubmit={onSubmitForm}>
      <Title>{title}</Title>
      <FormItem
        colon={false}
        label="Company name"
      >
        {getFieldDecorator('name', {
          rules: [
            {
              required: true,
              message: 'Please input name',
            },
            getMaxFieldLengthRule(70),
          ],
          initialValue: name,
        })(<InputField placeholder="Enter Company name..." size="large" name="name" />)}
      </FormItem>

      <FormItem
        colon={false}
        label="Business address"
      >
        {getFieldDecorator('businessAddress', {
          initialValue: businessAddress,
        })(<InputField placeholder="Enter Business address..." size="large" name="businessAddress" />)}
      </FormItem>

      <FormItem
        colon={false}
        label="Website"
      >
        {getFieldDecorator('website', {
          rules: [
            {
              pattern: URL,
              message: 'Please input valid website URL',
            },
          ],
          initialValue: website,
        })(<InputField placeholder="Enter website URL..." size="large" name="website" />)}
      </FormItem>

      <FormItem
        colon={false}
        label="LinkedIn"
      >
        {getFieldDecorator('linkedIn', {
          rules: [
            {
              pattern: URL,
              message: 'Please input valid LinkedIn URL',
            },
          ],
          initialValue: linkedIn,
        })(<InputField placeholder="Enter LinkedIn URL..." size="large" name="linkedIn" />)}
      </FormItem>

      <FormItem
        colon={false}
        label="Country"
      >
        <div onMouseDown={(e) => { e.preventDefault(); return false; }} >
          {getFieldDecorator('country', {
            ...(country && { initialValue: country }),
          })(<StyledSelect
            showSearch
            allowClear
            placeholder="Select Country..."
            defaultActiveFirstOption={false}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase().trim()) >= 0
            }
            getPopupContainer={triggerNode => triggerNode.parentNode}
          >
            { getData().map(item => (
              <Option key={item.code} value={item.code}>
                {item.name}
              </Option>
            ))}
          </StyledSelect>)}
        </div>
      </FormItem>

      <FormItem
        colon={false}
        label="Summary"
      >
        {getFieldDecorator('summary', { initialValue: summary })(<ReactQuillWrapped
          withPaddings
          theme="snow"
          height="100px"
          bounds="#text"
          withRightIndent
          scrollingContainer="#text"
          placeholder="Enter Summary..."
        />)}
      </FormItem>

      <ButtonWrapper>
        <CancelButton
          onClick={closeModal}
          disabled={isLoading}
        >
          Cancel
        </CancelButton>

        <ButtonSave
          key="submit"
          type="primary"
          htmlType="submit"
          loading={isLoading}
        >
          Save
        </ButtonSave>
      </ButtonWrapper>
    </Form>
  </Fragment>
);

CompanyForm.propTypes = {
  company: object,
  isLoading: bool,
  form: object.isRequired,
  title: string.isRequired,
  closeModal: func.isRequired,
  onSubmitForm: func.isRequired,
};

CompanyForm.defaultProps = {
  company: {},
  isLoading: false,
};

export default CompanyForm;



// WEBPACK FOOTER //
// ./src/components/company-form/index.js